import React from 'react';
import '../assets/styles/image-card.css'; 
import rasedLogo from '../assets/images/bank-logo.ico' 
import simIcon from '../assets/images/sim-icon.png' 
import wifiIcon from '../assets/images/wifi-icon.ico' 
import racIcon from '../assets/images/rac-icon.png' 

const ImageCard = ({title,onClick,cardIcon ,className,cornerIcon}) => {
    return (
      <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
      <div className={`ic-container mb-5 ${className}`} onClick={onClick} >
        <div className="ic-header">
          <div className="ic-logo">
            {
              cornerIcon? 
              <img src={ cornerIcon }   alt="RAC Icon" />
              :
              <img src={ racIcon }   alt="RAC Icon" />
            }
          </div>
          <h2>{title}</h2>
          <div className='ic-rasedLogo-container'>
          <img src={rasedLogo}   className='ic-rasedLogo' alt="Rased Bank Logo" />
          </div>
        </div>
        <div className="ic-card-details">
          <div className="ic-card-icons">
            <span className="ic-logo">
              <img src={wifiIcon} alt="Wifi Icon" />{/* Hardcoded Image */}
            </span>
            <div className="ic-card-icon">
              <img src={cardIcon} width='40'  alt="Account Icon" />  
            </div>
            <span className="ic-logo">
              <img src={simIcon} alt="Sim Icon" />{/* Hardcoded Image */}
            </span>
          </div>
          <div className="ic-card-numbers">
            <span className="ic-card-s-text">1 2 3 4</span>
            <span className="ic-card-s-text">4 5 6 7</span>
            <span className="ic-card-s-text">4 5 6 7</span>
            <span className="ic-card-s-text">8 9 9 8</span>
          </div>
        </div>
        <div className="ic-card-exp">
          <span className="ic-card-s-text">Exp 02/24</span>
          <span className="ic-card-s-text">Al-Shetaiwi</span>
        </div>
      </div>
      </div>
    );
  };
  
 
  export default ImageCard;
